import { useState } from "react";
import ListClients from "./components/ListClients";
import MantClients from "./components/MantClients";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
const MySwal = withReactContent(Swal);

const PageClient = () => {
    const [idEdit, setIdEdit] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [idArrayDeleted, setIdArrayDeleted] = useState(CONFIGURACIONES.INIT.ARRAY);

    const alertSwal = (message) => {
        return MySwal.fire({
            title: '¿Estás seguro?',
            html: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'No, cancelar',
            reverseButtons: true,
            allowOutsideClick: false,
            cancelButtonColor: "#f62d51",
            confirmButtonColor: "#2962FF"
        }).then((result) => {
            // if (result.isConfirmed) {
            //     let endpoint = url;
            //     return helpHttp().del(endpoint, options);
            // }
        });
    };

    const clicButtonDeleted = () => {
        if (idArrayDeleted.length == CONFIGURACIONES.INIT.NUMBER) {
            alert("NO SE PUEDE ELIMINAR")
        } else {
            console.log('idArrayDeleted', idArrayDeleted);
            alertSwal(`Estás a punto de eliminar los registros <strong>marcados</strong>`);
        }
    };

    const clicButtonAdd = () => {
        setIdEdit(CONFIGURACIONES.INIT.ID_ADD);
    };

    const clicButtonEdit = (refId) => {
        // console.log('refId', refId);
        
        if (idEdit === CONFIGURACIONES.INIT.ID_ADD) { 
            // console.log('Return Not');
            // setIdEdit(refId);
            return;
        }
        setIdEdit(refId);
    };

    const addArrayDeleted = (refId, refBoolean) => {
        if (!refBoolean) { setIdArrayDeleted(idArrayDeleted.filter(n => n !== refId)); return; }
        setIdArrayDeleted(prev => prev.includes(refId)?prev:[...prev, refId]);
    };

    const saveClient = async (form) => {
        console.log('form', form);
        
        // alert("OK SAve Client New");
        await Functions().save("url", "Se ha registrado correctamente", {});

        let isRenderUtil = localStorage.getItem('isRenderInit');
        console.log('isRenderUtil', isRenderUtil);
        
        localStorage.removeItem('isRenderInit');
       
    };
    
    const closeSection = () => {
        // console.log('close section...');
        setIdEdit(CONFIGURACIONES.INIT.ID_EDIT);
    };

    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {/* <button className="btn btn-danger" onClick={saveClient}>Click!</button> */}
                    <div className="col-md-8 col-xs-12">
                        <ListClients clicButtonEdit={clicButtonEdit} addArrayDeleted={addArrayDeleted} clicButtonDeleted={clicButtonDeleted} saveClient={saveClient} />
                    </div>

                    <div className="col-md-4 col-xs-12">
                        <MantClients idEdit={idEdit} clicButtonAdd={clicButtonAdd} saveClient={saveClient} closeSection={closeSection}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageClient;